



















































































































































































































































/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Component, Vue, Watch,
} from 'vue-property-decorator';
import AddIcon from 'mdi-vue/Plus';
import dayjs from 'dayjs';
import excel from 'exceljs';
import Table from '@/components/Table/Table.vue';
import TableBody from '@/components/Table/TableBody.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import Cell from '@/components/Table/Cell.vue';
import Button from '@/components/Button.vue';
import Loader from '@/components/Loader.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';
import Pagination from '@/components/Pagination.vue';
import ActionPopup from '@/components/ActionPopup.vue';
import ScrollbarWrapper from '@/components/ScrollbarWrapper.vue';
import Modal from '@/components/Modal.vue';
import Accordion from '@/components/Accordion.vue';
import CloseIcon from 'mdi-vue/Close';
import api, { apiSandbox } from '@/libs/api';
import format from '@/libs/numberFormat';
import { DisbursementsResponse, Disbursements } from '@/libs/api.interfaces';
import { AxiosError } from 'axios';
import { DateRange } from '@/components/DatePicker.vue';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import LayoutContent from '@/components/LayoutContent.vue';
import ModalPricing from './ModalPricing.vue';
import Alto from '../../../AccountManagement/Edit/Form/Alto.vue';
import BayarindWeb from '../../../AccountManagement/Edit/Form/BayarindWeb.vue';
import BcaKlikPay from '../../../AccountManagement/Edit/Form/BcaKlikPay.vue';
import BcaSakuku from '../../../AccountManagement/Edit/Form/BcaSakuku.vue';
import BcaVirtualAccount from '../../../AccountManagement/Edit/Form/BcaVirtualAccount.vue';
import BniIpay from '../../../AccountManagement/Edit/Form/BniIpay.vue';
import BniSyariahVirtualAccount from '../../../AccountManagement/Edit/Form/BniSyariahVirtualAccount.vue';
import BniVirtualAccount from '../../../AccountManagement/Edit/Form/BniVirtualAccount.vue';
import BPDPay from '../../../AccountManagement/Edit/Form/BPDPay.vue';
import BriePay from '../../../AccountManagement/Edit/Form/BriePay.vue';
import BriVirtualAccount from '../../../AccountManagement/Edit/Form/BriVirtualAccount.vue';
import CIMBClick from '../../../AccountManagement/Edit/Form/CIMBClick.vue';
import DANA from '../../../AccountManagement/Edit/Form/DANA.vue';
import DanamonVirtualAccount from '../../../AccountManagement/Edit/Form/DanamonVirtualAccount.vue';
import Indodana from '../../../AccountManagement/Edit/Form/Indodana.vue';
import IndosatDompetku from '../../../AccountManagement/Edit/Form/IndosatDompetku.vue';
import KartuKredit from '../../../AccountManagement/Edit/Form/KartuKredit(DoAcquire).vue';
import KlikBCA from '../../../AccountManagement/Edit/Form/KlikBCA.vue';
import Kredivo from '../../../AccountManagement/Edit/Form/Kredivo.vue';
import MandiriClickPay from '../../../AccountManagement/Edit/Form/MandiriClickPay.vue';
import MandirieCash from '../../../AccountManagement/Edit/Form/MandirieCash.vue';
import MandiriVirtualAccount from '../../../AccountManagement/Edit/Form/MandiriVirtualAccount.vue';
import Maybank2You from '../../../AccountManagement/Edit/Form/Maybank2You.vue';
import MaybankVirtualAccount from '../../../AccountManagement/Edit/Form/MaybankVirtualAccount.vue';
import PermataVirtualAccount from '../../../AccountManagement/Edit/Form/PermataVirtualAccount.vue';
import Atome from '../../../AccountManagement/Edit/Form/Atome.vue';
import AEON from '../../../AccountManagement/Edit/Form/AEON.vue';
import Ovo from '../../../AccountManagement/Edit/Form/Ovo.vue';
import Alfamart from '../../../AccountManagement/Edit/Form/Alfamart.vue';
import ShopeePay from '../../../AccountManagement/Edit/Form/ShopeePay.vue';
import Qris from '../../../AccountManagement/Edit/Form/Qris.vue';
import BncVirtualAccount from '../../../AccountManagement/Edit/Form/BncVirtualAccount.vue';
import Blu from '../../../AccountManagement/Edit/Form/Blu.vue';
import BtnVirtualAccount from '../../../AccountManagement/Edit/Form/BtnVirtualAccount.vue';
import TCash from '../../../AccountManagement/Edit/Form/TCash.vue';
import UnionPay from '../../../AccountManagement/Edit/Form/UnionPay.vue';
import ArtaGrahaVirtualAccount from '../../../AccountManagement/Edit/Form/ArtaGrahaVirtualAccount.vue';
import Easyinvoice from '../../../AccountManagement/Edit/Form/EasyInvoice.vue';
import Onepay from '../../../AccountManagement/Edit/Form/Onepay.vue';

interface ReportParams {
  status: string;
}

@Component({
  components: {
    ScrollbarWrapper,
    Button,
    AddIcon,
    ModalPricing,
    Table,
    TableBody,
    Row,
    Header,
    Cell,
    Loader,
    StatusIndicator,
    Pagination,
    ActionPopup,
    Modal,
    Accordion,
    CloseIcon,
    LayoutContent,
    Alto,
    BayarindWeb,
    BcaKlikPay,
    BcaSakuku,
    BcaVirtualAccount,
    BniIpay,
    BniSyariahVirtualAccount,
    BniVirtualAccount,
    BPDPay,
    BriePay,
    BriVirtualAccount,
    CIMBClick,
    DANA,
    DanamonVirtualAccount,
    Indodana,
    IndosatDompetku,
    KartuKredit,
    KlikBCA,
    Kredivo,
    MandiriClickPay,
    MandirieCash,
    MandiriVirtualAccount,
    Maybank2You,
    MaybankVirtualAccount,
    PermataVirtualAccount,
    BncVirtualAccount,
    ShopeePay,
    TCash,
    UnionPay,
    ArtaGrahaVirtualAccount,
    Easyinvoice,
    Onepay,
    Ovo,
    Alfamart,
    Atome,
    Qris,
    AEON,
  },
  methods: {
    format,
  },
})
export default class ReportTable extends Vue {
  loading = true;
  disbursements: any[] = [];
  modalPricing = false;
  // pagination
  page = 1;
  totalPage = 1;
  from = 0;
  to = 0;
  totalItem = 0;
  secretKey = '';
  channel = '';
  channelId = '';
  channelID = '';
  scChannelID = '';
  credentials = '';
  order = '';
  mcode = '';
  title = '';
  showModal = false;
  isSetting = false;
  isProduction = false;
  showProduction = true;
  showSandbox = true;
  isAddPaymentChannel = false;
  editedChannel = '';
  channelComponent = '';
  paymentChannel = [];
  paymentChannels: any = [];
  loadingSubmit = false
  loadingPage = true;
  filterPaymentChannels: any = [];
  merchantPaymentChannel: any = [];
  merchantPaymentChannelProd: any = [];

  BussinessModels = [
    { label: 'Direct Bundling', value: '0' },
    { label: 'Direct Non Bundling', value: '1' },
    { label: 'Escrow', value: '2' },
  ];

  format!: (val: number) => string;

  // eslint-disable-next-line spaced-comment
  channelCodes: { [key: string]: string[] } = {
    // 1072: ['Alto', 'Alto'],
    1022: ['BCA KlikPay', 'BcaKlikPay'],
    1024: ['BCA Sakuku', 'BcaSakuku'],
    1021: ['BCA Virtual Account', 'BcaVirtualAccount'],
    1041: ['BNI iPay', 'BniIpay'],
    1042: ['BNI Virtual Account', 'BniVirtualAccount'],
    1043: ['BNI Syariah Virtual Account', 'BniSyariahVirtualAccount'],
    1062: ['BRI Virtual Account', 'BriVirtualAccount'],
    1081: ['OCTO Click', 'CIMBClick'],
    1074: ['Danamon Virtual Account', 'DanamonVirtualAccount'],
    1061: ['BRI ePay', 'BriePay'],
    // 1071: ['Indosat Dompetku', 'IndosatDompetku'],
    2001: ['Kartu Kredit (DoAcquire)', 'KartuKredit'],
    2002: ['Kartu Kredit (PCS)', 'KartuKreditPCS'],
    1023: ['KlikBCA', 'KlikBCA'],
    1073: ['Kredivo', 'Kredivo'],
    // 1031: ['Mandiri eCash', 'MandirieCash'],
    1032: ['Mandiri Bill Payment', 'MandiriVirtualAccount'],
    // 1051: ['Maybank 2 you', 'Maybank2You'],
    1052: ['Maybank Virtual Account', 'MaybankVirtualAccount'],
    1011: ['Permata Virtual Account/Net', 'PermataVirtualAccount'],
    // 9999: ['Mandiri ClickPay', 'MandiriClickPay'],
    1077: ['TCASH', 'TCash'],
    // 9998: ['BPDPay', 'BPDPay'],
    // 1082: ['UnionPay', 'UnionPay'],
    1080: ['Indodana', 'Indodana'],
    1083: ['Bayarind Web', 'BayarindWeb'],
    1084: ['DANA', 'DANA'],
    1085: ['ShopeePay', 'ShopeePay'],
    1078: ['Homecredit', 'Homecredit'],
    9001: ['Onepay', 'Onepay'],
    9002: ['Easy Invoice', 'Easyinvoice'],
    1101: ['Arta Graha Virtual Account', 'ArtaGrahaVirtualAccount'],
    1012: ['Permata Net', 'PermataVirtualAccount'],
    1086: ['OVO', 'Ovo'],
    1087: ['Alfamart', 'Alfamart'],
    1088: ['Atome', 'Atome'],
    1089: ['QRIS', 'Qris'],
    1090: ['BNC Virtual Account', 'BncVirtualAccount'],
    1091: ['AEON', 'AEON'],
    1026: ['BLU', 'Blu'],
    1092: ['BTN Virtual Account', 'BtnVirtualAccount'],
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  async openDetail(id: any, bID: string) {
    if (bID === 'null' || bID === null) {
      if (id.service_code === '1021' || id.service_code === '1022') {
        this.credentials = id.credentials;
      } else {
        this.credentials = id.channel_id;
      }
      this.channelId = id.channel_id;
      this.title = id.service_name;
      this.order = 'pricing';
      this.showModal = true;
    } else {
      this.order = 'setting';
      this.channelID = bID;
      this.scChannelID = bID;
      this.showModal = true;
      this.isSetting = false;
      this.showProduction = true;
      this.showSandbox = true;
      this.isAddPaymentChannel = false;
      const [channelName, channelComponent] = this.channelCodes[id.toString()];
      this.editedChannel = channelName;
      this.channelComponent = channelComponent;
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  close(val: any) {
    this.modalPricing = val;
    this.channel = '';
    this.showModal = val;
  }

  closeModal() {
    this.showModal = false;
  }

  @Watch('page')
  onPageChange() {
    this.$router.push({
      query: { ...this.$route.query, page: this.page.toString() },
    });
    const params = {
      status: '',
    };
    this.getDisbursment(params, false, this.page);
  }

  async getDisbursment(params: ReportParams, isExport = false, page = this.page) {
    const id = this.$route.params.type;
    try {
      if (!isExport) {
        this.loading = true;
      }

      /* eslint-disable @typescript-eslint/camelcase */
      const { data } = await apiSandbox.get(`/consumer/channel/${id}`, {
        params: {
          page: this.page,
          export: isExport ? true : undefined,
        },
      });
      /* eslint-enable @typescript-eslint/camelcase */
      if (isExport) {
        return data;
      }
      this.$parent.$data.BusinessStatus = data.status;
      this.$parent.$data.reseller = true;

      this.mcode = data.merchant_code;
      this.page = page;
      this.disbursements = data.payment_list.data;
      this.totalPage = Math.ceil(data.payment_list.total / data.payment_list.per_page);
      this.from = data.payment_list.from;
      this.to = data.payment_list.to;
      this.totalItem = data.payment_list.total;
      this.loading = false;
      return null;
    } catch (err) {
      this.loading = false;
      return err as AxiosError;
    }
  }

  async requestPaymentChannel() {
    try {
      this.loadingSubmit = true;
      const code: any = [];
      this.paymentChannel.map((e: any) => (code.push(e.value)));

      await apiSandbox.post('merchant/payment-channel', {
        /* eslint-disable @typescript-eslint/camelcase */
        merchant_code: this.$route.params.type,
        service_code: code,
      });
      showToast(ToastType.SUCCESS, 'Success Create Channel', 'Congrats, your changes have been saved');
      this.loadingSubmit = false;
      this.getChannel();
      this.close(false);
    } catch (error) {
      this.loadingSubmit = false;
      showToast(ToastType.FAILED, 'Error', error.response.data.messsage);
      this.close(false);
    }
  }

  checkFilter(e: any) {
    if (e === 'apply') {
      this.getChannel();
    } else if (e === 'unselect') {
      this.getChannel();
    } else {
      this.filterPaymentChannels = [];
      this.getChannel();
    }
  }

  exitComponent(phase: string) {
    if (phase === 'production') {
      this.showProduction = false;
    } else {
      this.showSandbox = true;
    }
  }

  showComponent(phase: string) {
    if (phase === 'production') {
      this.channelID = '';
      this.showProduction = true;
    } else {
      this.channelID = '';
      this.showSandbox = true;
    }
  }

  async getChannel() {
    const id = this.$route.params.type;

    try {
      this.loadingPage = true;
      const { data } = await apiSandbox.get(`consumer/channel/${id}`, {
        params: {
          page: this.page,
          service_code: this.filterPaymentChannels.length !== 0
            ? this.filterPaymentChannels.map((e: any) => e.value) : undefined,
        },
      });
      this.merchantPaymentChannel = data.payment_list.data;
      // this.page = data.;
      this.totalPage = Math.ceil(data.payment_list.total / data.payment_list.per_page);
      this.from = data.payment_list.from;
      this.to = data.payment_list.to;
      this.totalItem = data.payment_list.total;
      this.loading = false;
      this.loadingPage = false;
    } catch (err) {
      console.error(err);
      // showToast(
      //   ToastType.FAILED,
      //   `Error [${(err as AxiosError).response?.status}]`,
      //   'Failed to get transaction detail',
      // );
    }
  }

  OnchangeBisnisModel(id: any) {
    return this.BussinessModels.find((e) => (e.value === id.toString()))?.label;
  }

  async export(params: ReportParams) {
    showToast(ToastType.SUCCESS, 'Export Disbursement',
      'Export is starting, please wait! This may take a while');

    try {
      const workbook = this.createWorkbook();
      await this.processExportPage(params, workbook, 1);
    } catch (err) {
      console.log(err);
      showToast(ToastType.FAILED,
        `Error [${(err as AxiosError).response?.status}]`, 'Failed to export disbursement');
    }

    showToast(ToastType.SUCCESS, 'Export Disbursement', 'Export finished');
  }

  // eslint-disable-next-line class-methods-use-this
  createWorkbook() {
    const workbook = new excel.Workbook();
    workbook.created = dayjs().toDate();

    const sheet = workbook.addWorksheet('Report', { views: [{ state: 'frozen', ySplit: 1 }] });

    sheet.getRow(1).font = { bold: true };
    sheet.columns = [
      { header: 'Date & Time Request', width: 18 },
      { header: 'Date & Time Disburse', width: 18 },
      { header: 'Reference ID', width: 14 },
      { header: 'Receiver Name', width: 40 },
      { header: 'Receiver Email', width: 40 },
      { header: 'Receiver Destination Bank', width: 14 },
      { header: 'Receiver Bank Account Name', width: 40 },
      { header: 'Receiver Bank Account Number', width: 32 },
      { header: 'Final Disbursement Amount', width: 18 },
      { header: 'Status', width: 10 },
    ];

    return workbook;
  }

  // eslint-disable-next-line class-methods-use-this
  async downloadSheet(workbook: excel.Workbook, part?: number) {
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer]);

    const fileURL = window.URL.createObjectURL(blob);
    const fileLink = document.createElement('a');

    const filename = `disbursement history${part ? `.part${part}` : ''}.xlsx`;

    fileLink.href = fileURL;
    fileLink.setAttribute('download', filename);
    document.body.appendChild(fileLink);
    fileLink.click();
  }

  async processExportPage(params: ReportParams, workbook: excel.Workbook, page = 1, part = 1) {
    try {
      const {
        data,
        last_page: lastPage,
        to,
      } = await this.getDisbursment(params, true, page) as DisbursementsResponse;

      const sheet = workbook.getWorksheet(1);

      data.forEach((item) => {
        sheet.addRow([
          item.disbursement_request,
          item.disbursement_date,
          item.reference_id,
          item.receiver_name,
          item.receiver_email,
          item.bank_destination,
          item.bank_account_name,
          item.bank_account_number,
          item.amount,
          item.status,
        ]);
      });

      if ((to / (100000 * part)) >= 1) {
        await this.downloadSheet(workbook, part);
        const newWorkbook = await this.createWorkbook();
        await this.processExportPage(params, newWorkbook, page + 1, part + 1);
      } else if (page < lastPage) {
        await this.processExportPage(params, workbook, page + 1, part);
      } else if (part > 1) {
        await this.downloadSheet(workbook, part);
      } else {
        await this.downloadSheet(workbook);
      }
    } catch (err) {
      console.log(err);
      showToast(ToastType.FAILED, 'Error', 'Failed to export disbursement');
    }
  }

  // eslint-disable-next-line class-methods-use-this
  dateFormat(time: string) {
    const formatted = dayjs(time).format('MMMM D, YYYY HH:mm:ss');
    if (formatted === 'Invalid Date') {
      return '-';
    }

    return formatted;
  }
}
